<template>
	<div class="scientific-resource">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right">
										<Breadcrumb />
									</div>
									<h3 class="header-title mb-3">科研资源</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<el-form ref="queryForm" :inline="true" :model="queryForm" label-width="80px">
											<el-form-item label="">
												<el-input v-model="queryForm.name" placeholder="资源名称"></el-input>
											</el-form-item>
											<el-form-item label="">
												<el-select v-model="queryForm.resourcesId" clearable placeholder="请选择">
													<el-option v-for="item in scientificResourceType" :key="item.id"
														:label="item.name" :value="item.id">
													</el-option>
												</el-select>
											</el-form-item>
											<el-form-item label="">
												<el-button type="primary" @click="queryData">查询</el-button>
											</el-form-item>
											<el-form-item label="">
												<el-button type="success">导出Excel</el-button>
											</el-form-item>
										</el-form>
										<!-- 资源表格 -->
										<el-table :header-cell-style="tableStyle" :data="scientificResourceList" border
											style="width: 100%">
											<el-table-column prop="name" label="资源名称" width="180">
												<template v-slot="scope">
												  <el-link type="primary" :underline="false" @click="downloadFile(scope.row)">{{scope.row.name}}</el-link>
												</template>
											</el-table-column>
											<el-table-column prop="adminName" label="上传人" width="180"></el-table-column>
											<el-table-column prop="adminUnitName" label="所属单位"></el-table-column>
											<el-table-column prop="resourcesName" label="类别"></el-table-column>
											<el-table-column prop="createTime" label="上传时间"></el-table-column>
											<el-table-column prop="" label="操作">
												<template v-slot="scope">
													<el-button type="primary"
														@click="uploadOrEditResource('edit', scope.row)">修改
													</el-button>
													<el-button type="danger" @click="delResource(scope.row.id)">删除
													</el-button>
												</template>
											</el-table-column>
										</el-table>
										<!-- 分页器 -->
										<div class="pagination">
											<el-pagination @size-change="handleSizeChange"
												@current-change="handleCurrentChange"
												:current-page="queryForm.pageNumber" :page-sizes="[10, 20, 50, 100]"
												:page-size="queryForm.pageSize"
												layout="total, sizes, prev, pager, next, jumper" :total="total">
											</el-pagination>
										</div>
										<div class="btn-wrap">
											<el-button type="primary" @click="uploadOrEditResource('add')">上传
											</el-button>
										</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<el-form :model="resourceForm" :rules="resourceFormRules" ref="resourceFormRef" label-width="100px"
				class="demo-resourceForm">
				<el-form-item label="选择资源" prop="name">
					<UploadFile @file-event="changeData('resource', $event)" @delFile="delFile"
						:value="resourceForm.resource" />
				</el-form-item>
				<el-form-item label="资源类别" prop="resourcesId">
					<el-radio-group v-model="resourceForm.resourcesId" @change="resouceTypeChange">
						<el-radio :label="item.id" v-for="(item,index) in scientificResourceType" :key="index">{{item.name}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addOrEditResource">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import UploadFile from './components/UploadFile.vue'
	import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue'
	import {
		getPlatformInformationData
	} from "@/api/after/systemManagement.js";
	import {
		getScientificResourceList,
		addOrEditScientificResource,
		delScientificResource
	} from '@/api/after/scientificResource.js'
	import {downloadFile} from '@/api/public.js'
	export default {
		components: {
			Breadcrumb,
			UploadFile
		},
		data() {
			return {
				// 查询科研资源表单
				queryForm: {
					"name": "", //资源名称
					"pageNumber": 1,
					"pageSize": 10,
					"resourcesId": null, //资源类别
				},
				total: 0,
				dialogVisible: false,
				dialogTitle: '上传科研资源',
				// 添加科研资源表单
				resourceForm: {
					resource: {
						id: '',
						name: ''
					},
					name: null, //资源名称
					annexId: null, //资源id
					resourcesFormat: null, //资源后缀名
					resourcesId: null, //资源类别ID
					resourcesName: null, //资源类别名称
				},
				resourceFormRules: {
					name: [{
						required: true,
						message: '请上传资源！',
						trigger: 'change'
					}],
					resourcesId: [{
						required: true,
						message: '请选择资源类别！',
						trigger: 'change'
					}],
				},
				scientificResourceList: [], //科研资源列表
				scientificResourceType: [], //科研资源类别
				tableStyle: {
					backgroundColor: '#4da7dc',
					color: '#fff',
					textAlign: 'center'
				}
			}
		},
		async created() {
			await this.getScientificResourceType()
			this.getScientificResourceList()
		},
		methods: {
			// 下载附件
			async downloadFile(data){
				const res = await downloadFile(data.annexId)
				//创建一个a标签并实现下载功能
				const link = document.createElement('a');
				let blob = new Blob([res], { type: 'application/octet-stream' });//res是文件流
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.download = data.name + data.resourcesFormat; //下载的文件名
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			// 添加或者修改资源
			addOrEditResource() {
				this.$refs.resourceFormRef.validate(valid => {
					if (valid) {
						// console.log('数据', this.resourceForm);
						// const data = JSON.parse(JSON.stringify(this.resourceForm))
						this.addOrEditScientificResource()
					}
				})

			},
			// 获取科研资源列表
			async getScientificResourceList() {
				const res = await getScientificResourceList(this.queryForm)
				console.log('科研资源列表', res);
				if (res.code == 200) {
					this.scientificResourceList = res.data.records
					this.total = res.data.total
				} else {
					this.$message.error(res.data)
				}
			},
			// 删除资源
			async delScientificResource(id) {
				const res = await delScientificResource(id)
				if (res.code == 200) {
					this.$message.success('删除成功！')
					this.getScientificResourceList()
				} else {
					this.$message.error(res.data)
				}
			},
			// 添加或者修改科研资源接口
			async addOrEditScientificResource() {
				const res = await addOrEditScientificResource(this.resourceForm)
				if (res.code == 200) {
					if (this.resourceForm.id) {
						this.$message.success('修改成功！')
					} else {
						this.$message.success('添加成功！')
					}
					this.dialogVisible = false
					this.resourceForm = {
						resource: {
							id: '',
							name: ''
						},
						name: null, //资源名称
						annexId: null, //资源id
						resourcesFormat: null, //资源后缀名
						resourcesId: null, //资源类别ID
						resourcesName: null, //资源类别名称
					}
					this.getScientificResourceList()
				} else {
					this.$message.error(res.data)
				}
			},
			// 获取科研资源类别
			async getScientificResourceType() {
				const res = await getPlatformInformationData(3);
				console.log("科研资源类别", res);
				if (res.code == 200) {
					this.scientificResourceType = res.data;
				} else {
					this.$message.error(res.data);
				}
			},
			// 资源类别改变
			resouceTypeChange() {
				let obj = this.scientificResourceType.find(item => {
					return item.id == this.resourceForm.resourcesId
				})
				this.resourceForm.resourcesName = obj.name
			},
			// 查询数据
			queryData() {
				this.queryForm.pageNumber = 1
				this.getScientificResourceList()
			},
			handleSizeChange(val) {
				this.queryForm.pageSize = val
				this.getScientificResourceList()
			},
			handleCurrentChange(val) {
				this.queryForm.pageNumber = val
				this.getScientificResourceList()
			},
			// 上传或者修改资源
			uploadOrEditResource(type, data) {
				if (type === 'add') {
					this.dialogTitle = '上传科研资源'
					this.resourceForm = {
						resource: {
							id: '',
							name: ''
						},
						name: null, //资源名称
						annexId: null, //资源id
						resourcesFormat: null, //资源后缀名
						resourcesId: null, //资源类别ID
						resourcesName: null, //资源类别名称
					}
				} else if (type === 'edit') {
					this.dialogTitle = '修改科研资源'
					this.resourceForm = JSON.parse(JSON.stringify(data))
					this.resourceForm.resource = {
						id: data.annexId,
						name: data.name + data.resourcesFormat
					}
					console.log('回显数据', this.resourceForm);
				}
				this.dialogVisible = true
			},
			// 删除科研资源
			delResource(id) {
				this.$confirm('确定删除该文件？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.delScientificResource(id)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			changeData(name, data) {
				this.resourceForm[name] = data;
				this.resourceForm.name = data.name.slice(0, data.name.indexOf('.')); //资源名称
				this.resourceForm.annexId = data.id //资源id
				// this.resourceForm.resourcesFormat = data.name.slice(data.name.indexOf('.'), -1); //资源后缀名
				if(data.name){
					this.resourceForm.resourcesFormat = /\.(\w+)$/.exec(data.name)[0]; //资源后缀名
				}
			},
			// 删除资源文件
			delFile() {
				console.log('删除上传文件');
				this.resourceForm.resource = {
					id: '',
					name: ''
				}
				this.resourceForm.name = null
				this.resourceForm.annexId = null
				this.resourceForm.resourcesFormat = null
			},
		},
	}
</script>

<style scoped lang="scss">
	.pagination {
		display: flex;
		justify-content: center;
		margin-top: 10px;
	}
</style>
